/**
 * Tab manager class.
 * To be instanciated then used by widgets based on tabs (e.g. Tablist, Accordion, Tree).
 */

// Constants (classes)
const activeClass = 'active';
const inactiveClass = 'inactive';
const iconCSSClass = 'a-icon-css';
const iconArrowUpClass = 'a-icon-css--arrow-up';
const iconArrowDownClass = 'a-icon-css--arrow-down';
const iconArrowLeftClass = 'a-icon-css--arrow-left-language-sensitive';
const iconArrowRightClass = 'a-icon-css--arrow-right-language-sensitive';

// Constants (events)
const hideTabEvent = 'hide.tab';
const showTabEvent = 'show.tab';

class TabManager {
  constructor(aoTabs, aoOptions) {
    this.$tabs = $(aoTabs);
    this.options = {
      change: null,
      handleContentDisplay: false,
    };

    Object.assign(this.options, aoOptions);
  }

  /**
   * Hides the content container.
   * @param {Object}  aoContainer   - The content container.
   * @param {Boolean} [abNoTrigger] - No trigger please.
   */
  hideContent(aoContainer, abNoTrigger) {
    const $contentContainer = $(aoContainer);

    if (!$contentContainer.length) {
      return false;
    }

    $contentContainer
      .attr('aria-hidden', true)
      .removeClass(activeClass)
      .addClass(inactiveClass);

    if (this.options.handleContentDisplay) {
      $contentContainer.hide();
    }

    if (!abNoTrigger) {
      $contentContainer.trigger(hideTabEvent);
    }

    return true;
  }

  /**
   * Shows the content container.
   * @param {Object} aoContainer - The content container.
   */
  showContent(aoContainer) {
    const $contentContainer = $(aoContainer);

    $contentContainer
      .attr('aria-hidden', false)
      .addClass(activeClass)
      .removeClass(inactiveClass);

    if (this.options.handleContentDisplay) {
      $contentContainer.show();
    }

    $contentContainer.trigger(showTabEvent);
  }

  /**
   * Sets a tab as selected.
   * @param {Object} aoTab             - Tab object.
   * @param {Boolean} [abHandleActive] - Should handle active state?
   */
  setSelected(aoTab, abHandleActive) {
    const $tab = $(aoTab);

    if (!$tab.length) {
      return;
    }

    const $otherTabs = this.$tabs.not($tab);

    // unselect + inactivate other tabs
    $otherTabs.attr({
      'aria-selected': false,
      tabindex: -1,
    });
    if (abHandleActive) {
      $otherTabs
        .removeClass(activeClass)
        .addClass(inactiveClass);
    }

    // select + activate new tab
    $tab.attr({
      'aria-selected': true,
      tabindex: 0,
    });
    if (abHandleActive) {
      $tab
        .addClass(activeClass)
        .removeClass(inactiveClass);
    }
  }

  getPreviousTab(aoTab) {
    let $resultTab = {};

    this.$tabs.each((anIndex, aoElement) => {
      if ($(aoTab).is($(aoElement)) && (anIndex > 0)) {
        $resultTab = this.$tabs.eq(anIndex - 1);

        return false; // break
      }

      return true; // continue
    });

    return $resultTab;
  }

  getNextTab(aoTab) {
    let $resultTab = {};
    const lastIndex = this.$tabs.length - 1;

    this.$tabs.each((anIndex, aoElement) => {
      if ($(aoTab).is($(aoElement)) && (anIndex < lastIndex)) {
        $resultTab = this.$tabs.eq(anIndex + 1);

        return false; // break
      }

      return true; // continue
    });

    return $resultTab;
  }

  static changeIconCss(element, firstIconCssClass, secondIconCssClass) {
    if (element.hasClass(firstIconCssClass)) {
      element
        .removeClass(firstIconCssClass)
        .addClass(secondIconCssClass);
    } else if (element.hasClass(secondIconCssClass)) {
      element
        .removeClass(secondIconCssClass)
        .addClass(firstIconCssClass);
    }
  }

  static toggleIcon(aoTab) {
    const $tab = $(aoTab);

    if (!$tab.length) {
      return;
    }

    const $icon = $tab.find(`.${iconCSSClass}`).first();
    if ($icon.length) {
      TabManager.changeIconCss($icon, iconArrowUpClass, iconArrowDownClass);
      TabManager.changeIconCss($icon, iconArrowLeftClass, iconArrowRightClass);
    }
  }
}

export default TabManager;



// WEBPACK FOOTER //
// ./js/common/widgets/TabManager.js